import { render } from "./ConsultasRecientes.vue?vue&type=template&id=4ed8943a"
import script from "./ConsultasRecientes.vue?vue&type=script&lang=js"
export * from "./ConsultasRecientes.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__